var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"log-containers"},[(_vm.data.length > 0)?_c('div',_vm._l((_vm.data),function(item,index){return _c('p',{key:index},[_c('code',{staticClass:"show-log",domProps:{"innerHTML":_vm._s(item)}})])}),0):_c('div',[_c('p',{staticClass:"log-nr"},[_vm._v("\n            暂无日志\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }